import { styles } from './styles';
import ReactDOMServer from 'react-dom/server';
import { format } from "date-fns";
import { convertTimestampToDay } from '../../../utils/convertTimestampToDay';

export function createHTML(
    organizedOccurrences,
    title,
    length,
    beautifulName,
    includeServiceStart,
    includeResolutionTime
) {
    return `
            <html>
            <head>
                <meta charset="UTF-8">
                <style>
                    body {
                        margin: 20px 20px;
                        font-family: 'Arial Nova', Arial, sans-serif;
                        font-weight: normal;
                        print-color-adjust: exact;
                        -webkit-print-color-adjust: exact;
                    }
                    @page{
                        margin: 50px 20px
                    }
                </style>
                <title>${title}</title>
            </head>

                <body>
                    ${ReactDOMServer
            .renderToStaticMarkup(
                tableStudents(
                    organizedOccurrences,
                    length,
                    beautifulName,
                    includeServiceStart,
                    includeResolutionTime
                ))}
                </body>
            </html>
        `;
}

function tableStudents(
    organizedOccurrences,
    length,
    beautifulName,
    includeServiceStart,
    includeResolutionTime
) {
    const publicPathAssets = window.location.origin + '/assets';

    return (
        <>
            <div>
                <div style={styles.header}>
                    <img src={`${publicPathAssets}/LogoFalaCanaa.png`} style={styles.logo} alt="Logo" />
                    <p style={styles.title}>
                        Prefeitura Municipal de Canaã dos Carajás Conecta Canaã
                    </p>
                    <img src={`${publicPathAssets}/canaa-bandeira.png`} style={styles.flag} alt="Logo" />
                    <p>Emitido em: {format(Date.now(), "dd/MM/yyyy 'às' HH:mm")}</p>
                </div>
            </div>

            <div style={styles.subtitle}>
                <p>Relatório por {beautifulName}</p>
                <p>Total de registros: {length}</p>
            </div>

            <hr style={styles.containerTable} />
            {
                Object.keys(organizedOccurrences).map((valueAttribute, key) => (
                    <div style={{ marginTop: '40px' }} key={key}>
                        <span>{valueAttribute}</span>
                        <table style={styles.table}>
                            <thead>
                                <tr style={{ backgroundColor: 'rgb(211, 211, 211)' }}>
                                    <th style={{ ...styles.tableHead, width: '25%' }}>
                                        Código
                                    </th>
                                    {!includeServiceStart && !includeResolutionTime ?
                                        <th style={{ ...styles.tableHead, width: '15%' }}>
                                            Status
                                        </th> : false
                                    }

                                    <th style={{ ...styles.tableHead, width: '20%' }}>
                                        Tipo
                                    </th>
                                    <th style={{ ...styles.tableHead, width: '20%' }}>
                                        Bairro
                                    </th>

                                    {includeServiceStart ?
                                        <th style={{ ...styles.tableHead, width: '15%' }}>
                                            Tempo de Início de atendimento
                                        </th> : false
                                    }

                                    {includeResolutionTime ?
                                        <th style={{ ...styles.tableHead, width: '15%' }}>
                                            Tempo de resolução de ocorrência
                                        </th> : false
                                    }
                                </tr>
                            </thead >
                            <tbody>

                                {
                                    organizedOccurrences[valueAttribute].map((item, key) => (
                                        <tr key={key}>
                                            <td style={styles.tableRow}>
                                                &nbsp;&nbsp; {item.reference}
                                            </td>
                                            {!includeServiceStart && !includeResolutionTime ?
                                                <td style={styles.tableRow}>
                                                    &nbsp;&nbsp; {item.status}
                                                </td> : false
                                            }

                                            <td style={styles.tableRow}>
                                                &nbsp;&nbsp; {item.area}
                                            </td>

                                            <td style={styles.tableRow}>
                                                &nbsp;&nbsp; {item.neighborhood}
                                            </td>

                                            {includeServiceStart || includeResolutionTime ?
                                                //Atualmente para pegar o resolution time presisa que a ocorrência seja do tipo
                                                //Resolvido e basta eu subtrair updatedAt - createdAt

                                                //Para o início de atendimeto é similar, entretanto, a ocorrência é do tipo
                                                //"Em análise", esses filtros já seram feitos em camadas superiores
                                                <td style={styles.tableRow}>
                                                    &nbsp;&nbsp; {convertTimestampToDay((new Date(item.updatedAt) - new Date(item.createdAt)))}
                                                </td> : false
                                            }
                                        </tr>
                                    ))
                                }

                                <tr style={styles.lastRowTable}>
                                    <td colSpan="3">
                                        &nbsp;&nbsp;Total de Ocorrências:
                                    </td>

                                    <td>
                                        &nbsp;&nbsp;{organizedOccurrences[valueAttribute].length}
                                    </td>
                                </tr>

                            </tbody>
                        </table >
                    </div >
                ))
            }
        </>
    );
}

export function organizeOccurrences(occurrences, attributeForOrganize, includeUndefined = true) {
    let organizedOccurrences = {};

    occurrences.forEach((occurrence) => {
        const attrValue = occurrence[attributeForOrganize];

        if (!attrValue) {
            if (includeUndefined) {
                if (!!organizedOccurrences["Indefinido"]) {
                    organizedOccurrences["Indefinido"].push(occurrence);
                } else {
                    organizedOccurrences["Indefinido"] = [occurrence];
                }
            }
        } else {
            if (!!organizedOccurrences[attrValue]) {
                organizedOccurrences[attrValue].push(occurrence);
            } else {
                organizedOccurrences[attrValue] = [occurrence];
            }
        }

    });

    return organizedOccurrences;

}